import * as actions from 'actions';
import {
    getGenericEmailTypes,
    createGenericEmailType as createGenericEmailTypeApi,
    deleteGenericEmailType as deleteGenericEmailTypeApi,
} from 'TamtamAPI';

export const fetchGenericEmailTypes = (targetApp = null) => {
    return (dispatch, getState) => {
        const { token } = getState().auth;
        const resolvedTargetApp = targetApp || getState().settings.targetApp;
        return dispatch(actions.fetchGenericEmailTypes(
            getGenericEmailTypes(token, resolvedTargetApp)
        ));
    };
};

export const createGenericEmailType = (data) => {
    return (dispatch, getState) => {
        const { token, user } = getState().auth;
        return dispatch(actions.createGenericEmailType(
            createGenericEmailTypeApi(token, {
                ...data,
                updatedBy: user && user.id,
            })
        ));
    };
};

export const deleteGenericEmailType = (code, targetApp, scope = "global") => {
    return (dispatch, getState) => {
        const { token } = getState().auth;
        const configId = getState().genericEmail.currentSetting.id;
        return dispatch(actions.deleteGenericEmailType(
            deleteGenericEmailTypeApi(token, code, targetApp, configId, scope)
        ));
    };
};
